import { render, staticRenderFns } from "./PrestigeEditCampaignTag.vue?vue&type=template&id=e7538d3c"
import script from "./PrestigeEditCampaignTag.vue?vue&type=script&lang=js"
export * from "./PrestigeEditCampaignTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports